<template>
    <div class="live-wrap">
        <header>
            <h1>Tonton Sepak Bola - Live Sepak Bola Gratis</h1>
        </header>
        <ul :class="{'without-banner': !footerShow}">
            <li v-for="match in list" :key="match.match_id" :class="{top: match.is_top}" @click="showDialog()">
                <div class="home">
                    <img :src="getImgSrc(match.team_A_logo)" alt="">
                    <p>{{match.team_A_name}}</p>
                </div>
                <div class="away">
                    <img :src="getImgSrc(match.team_B_logo)" alt="">
                    <p>{{match.team_B_name}}</p>
                </div>
                <div class="status" v-if="match.status !== 'Playing'">
                    <p class="competition">{{match.competition_name}}</p>
                    <p class="time">{{formatData(match.start_play)}}</p>
                </div>
                <div class="status" v-if="match.status === 'Playing'">
                    <p class="minute">{{match.minute}}'</p>
                    <p class="score">{{match.team_A_score}} - {{match.team_B_score}}</p>
                    <label for="score">Skor Langsung</label>
                </div>
            </li>
        </ul>
        <footer v-if="footerShow" @click="downloadFooter()">
            <div class="logo">
                <img src="../assets/logo.png" alt="">
            </div>

            <div class="btns">
                <button>Dapatkan Gratis</button>
                <span @click.stop.prevent="footerShow=false" class="close-wrap">
                    <img src="../assets/close.png" class="close" alt="">
                </span>
            </div>
            <h2>All Sepakbola</h2>
            <span>Semua Skor Sepak Bola Terbaru</span>
        </footer>

        <transition name="fade">
            <div class="overlay" v-if="modalShow" @touchmove.prevent>
                <div class="modal" @click="downloadModal()">
                    <div class="close" @click.prevent.stop="modalShow=false">
                        <img src="../assets/close.png" class="close" alt="">
                    </div>
                    <div class="content" v-html="alertText">

                    </div>
                    <div class="download">
                        <div class="logo">
                            <img src="../assets/logo.png" alt="">
                        </div>

                        <div class="btns">
                            <button>Get it Free</button>
                        </div>
                        <h2>All Sepakbola</h2>
                        <span class="star"></span>
                        <span class="star"></span>
                        <span class="star"></span>
                        <span class="star"></span>
                        <span class="star"></span>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
    import axios from 'axios';
    import { detectUa } from '@/util/util';
    import 'core-js/es6';

    export default {
        data () {
            return {
                footerShow: true,
                modalShow: false,
                listClicked: false,
                iOSUrl: '',
                androidUrl: '',
                alertText: '20 juta orang menggunakan Aplikasi \nAll Sepakbola App.',
                list: []
            };
        },
        mounted () {
            const utm_source = this.$route.query['from'] || this.$route.query['utm_source'];
            this.$loading('loading');
            axios.get(global.apiDomain + '/m/data/sem/match?utm_source=' + utm_source).then((res) => {
                const data = res.data;
                if (data.errno) {
                    this.$toast(data.errmsg);
                    return;
                }

                this.$loading.close();

                Object.assign(this, data.data);

                // 置顶排序
                this.list.sort((a, b) => {
                    if (a.is_top && !b.is_top) {
                        return -1;
                    }
                    if (!a.is_top && b.is_top) {
                        return 1;
                    }
                    return 0;
                });
                this.modalShow = true;
            }, res => {
                // error callback
            });
        },
        methods: {
            formatData (gmtDate) {
                let date = new Date(gmtDate.replace(/-/g, '/')).getTime();
                let diffMin = new Date().getTimezoneOffset();
                let localDate = new Date(date - diffMin * 60 * 1000);

                let prefixZero = s => ('0' + s).slice(-2);
                let day = [prefixZero(localDate.getMonth() + 1), prefixZero(localDate.getDate())].join('-');
                let time = [prefixZero(localDate.getHours()), prefixZero(localDate.getMinutes())].join(':');

                return [day, time].join(' ');
            },
            showDialog () {
                this.modalShow = true;
                this.listClicked = true;
                ga('send', 'event', 'sem', 'modalshow');
            },
            download () {
                const browser = detectUa();

                if (browser.isAndroid) {
                    location.href = this.androidUrl;
                } else {
                    location.href = this.iOSUrl;
                }
            },
            downloadModal () {
                ga('send', 'event', 'sem', 'download', 'modal', this.listClicked);
                this.download();
            },

            downloadFooter () {
                ga('send', 'event', 'sem', 'download', 'footer');
                this.download();
            }
        }
    };
</script>

<style lang="less">
    body .lx-load-box {
        width: 4rem;
        height: 4rem;
        min-height: 0;
        margin-left: -2rem;
        top: 220px;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }

    .overlay {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, 0.4);

        .close {
            position: absolute;
            top: -0.3rem;
            right: -0.3rem;
            width: 1.5rem;
            height: 1.5rem;
        }

        .modal {
            width: 84%;
            height: 10rem;
            text-align: center;
            background: #fff;
            margin: auto;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            border-radius: 4px;
            .content {
                padding: 1.375rem;
                font-size: 1rem;
                background: #f7f7f7;
                line-height: 1.5;
                font-weight: bold;
                border-radius: 4px 4px 0 0;
                min-height: 2.8rem;
                white-space: pre-line;

                b {
                    color: #24af41;
                }
            }
            .download {
                padding: 1rem 1.25rem;
                text-align: left;
                background: #fff;
                border-radius: 0 0 4px 4px;
            }

            h2 {
                font-size: 1.2rem;
            }
            .star {
                background: url(../assets/star.png) no-repeat;
                background-size: 100%;
                display: inline-block;
                vertical-align: top;
                width: 0.8rem;
                height: 0.8rem;
            }

            .logo {
                width: 2.37rem;
                line-height: 1;
                font-size: 0;
                float: left;
                margin-right: 0.5rem;
            }

            .btns {
                float: right;
                padding: 0.26rem 0;

                button {
                    background: #24af41;
                    color: #fff;
                    height: 1.75rem;
                    line-height: 1.75rem;
                    width: 5.5rem;
                    text-align: center;
                    border: none;
                    -webkit-appearance: none;
                    border-radius: 2px;
                }

                img {
                    width: 1rem;
                    height: 1rem;
                    margin-left: 0.26rem;
                    margin-right: -0.26rem;
                    position: relative;
                    top: 0.15rem;
                }
            }
        }
    }

    .live-wrap {
        color: #111;
        font-family: 'Source Han Sans', Arial, "Helvetica Neue", Helvetica, sans-serif;
    }

    header h1 {
        height: 2.92rem;
        background: #24af41;
        color: #fff;
        font-size: 1rem;
        line-height: 2.92rem;
        text-align: center;
    }

    ul {
        padding-bottom: 4rem;

        &.without-banner {
            padding-bottom: 0rem;
        }
    }

    li {
        list-style: none;
        border-bottom: 1px solid #eee;
        clear: both;
    }

    li:last-child {
        border: none;
    }

    li.top {
        background: #fffcdc;
        border: none;
    }

    .home, .away {
        float: left;
        width: 6.875rem;
        overflow: hidden;
        text-align: center;
        padding: 1.25rem 0;

        img {
            width: 2.375rem;
        }

        p {
            font-size: 0.8em;
            line-height: 1.1;
        }
    }

    .away {
        float: right;
    }

    .status {
        height: 6rem;
        text-align: center;
        box-sizing: border-box;

        .competition {
            font-size: 0.8em;
            padding: 1.18rem 0 0;
            color: #999;
            line-height: 1.2;
        }
        .time {
            font-size: 1rem;
            line-height: 2.2;
        }
        .minute {
            padding-top: 1rem;
            color: #24af41;
            font-size: 0.8rem;
            line-height: 1;
        }
        .score {
            font-size: 1.5rem;
            color: #24af41;
            letter-spacing: 0.4rem;
            text-indent: 0.2rem;
        }
        label {
            width: 5.5rem;
            height: 1.25rem;
            color: #fff;
            display: inline-block;
            background: #24af41;
            font-size: 0.8rem;
            line-height: 1.25rem;
            border-radius: 2px;
            margin-top: 0.4rem;
        }
    }

    footer {
        position: fixed;
        width: 100%;
        background: #fff;
        bottom: 0;
        padding: 0.75rem 1.25rem;
        box-shadow: 0 0 6px rgba(0, 0, 0, 0.2);
        box-sizing: border-box;

        h2 {
            font-size: 1.2rem;
        }
        span {
            font-size: 0.8rem;
            color: #999;
        }

        .logo {
            width: 2.37rem;
            line-height: 1;
            font-size: 0;
            float: left;
            margin-right: 0.5rem;
        }

        .close-wrap {
            display: inline-block;
            height: 1.45rem;
            vertical-align: top;
            width: 1.75rem;
            margin-right: -1rem;
            padding-top: 0.3rem;
        }

        .btns {
            float: right;
            padding: 0.26rem 0;

            button {
                background: #24af41;
                color: #fff;
                height: 1.75rem;
                line-height: 1.75rem;
                width: 5.5rem;
                text-align: center;
                border: none;
                -webkit-appearance: none;
                border-radius: 2px;
            }

            img {
                width: 1rem;
                height: 1rem;
                margin-left: 0.26rem;
                margin-right: -0.26rem;
            }
        }
    }
</style>




// WEBPACK FOOTER //
// AppLiveList.vue?39169e26